exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yo-view-of-chat[data-v-7046b8a2]{width:100%;display:none;height:100%;overflow:auto}@media screen and (min-width:767px){.yo-view-of-chat[data-v-7046b8a2]{display:block;width:calc(100% - 303px)}}.yo-view-of-chat.yo-open-menu[data-v-7046b8a2]{display:block}.marginer[data-v-7046b8a2]{margin:30px}.all-center[data-v-7046b8a2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
